import { openDB } from "idb";
const version = 2;
const dbName = "table-store";
let dbPromise;
// let dbPromise = openDB(dbName, version, {
//   upgrade(db) {
//     console.log('cache initialized');
//   }
// });

const db = {
  version: version,
  initializeDbStores(tables, version) {
    dbPromise = openDB(dbName, version, {
      upgrade(db) {
        console.log('creating stores', tables);
        db.createObjectStore("tables", { keyPath: "id" });
        let userStore = db.createObjectStore("users", { keyPath: "id" });
        userStore.createIndex("name", "name");
        tables.forEach(table => {
          let tableStore = db.createObjectStore(table.id, { keyPath: "id" });
          tableStore.createIndex("name", "name");
        });
      }
    });
    return dbPromise;
  },
  async get(key, table = "tables") {
    return (await dbPromise).get(table, key);
  },
  async set(val, table = "tables") {
    return (await dbPromise).put(table, val, undefined);
  },
  async setAll(valueList, table = "tables") {
    const tx = (await dbPromise).transaction(table, 'readwrite');
    let store = tx.objectStore(table);
    valueList.forEach(value => {
      store.add(value);
    })
    await tx.done;
  },
  async setWithKey(key, val, table = "tables") {
    return (await dbPromise).put(table, val, key);
  },
  async delete(key, table = "tables") {
    return (await dbPromise).delete(table, key);
  },
  async clear(table = "tables") {
    return (await dbPromise).clear(table);
  },
  async keys(table = "tables") {
    return (await dbPromise).getAllKeys(table);
  },
  async getAll(table = "tables") {
    return (await dbPromise).getAll(table);
  }
};

export default db;
